import { create } from 'zustand'

import { ReactCallBackFunction } from 'src/types/CallbackFunction'

interface FreezedTagItemsStore {
  freezedTagItems: Record<string, string[]>
  setFreezedTagItems: ReactCallBackFunction<Record<string, string[]>>
}

const useFreezedTagItemsStore = create<FreezedTagItemsStore>(set => ({
  freezedTagItems: {},
  setFreezedTagItems: items =>
    set(s => {
      if (typeof items === 'function') {
        return {
          freezedTagItems: items(s.freezedTagItems),
        }
      }
      return { freezedTagItems: items }
    }),
}))

export default useFreezedTagItemsStore
